import { render, staticRenderFns } from "./ReceivedLootTable.vue?vue&type=template&id=76962514&scoped=true"
import script from "./ReceivedLootTable.vue?vue&type=script&lang=js"
export * from "./ReceivedLootTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76962514",
  null
  
)

export default component.exports